// @flow
import client from '../../client'

// Constants
export const EMAIL_UNSUBSCRIBE_ENDPOINT = '/corporate/email/unsubscribe/'

/**
 * Unsubscribe user from email list
 * @param {object} data User data
 * @param {string} data.token Email token
 * @param {string} data.reason The reason why the user unsubscribed
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const unsubscribeEmail = (data: {
  token: string,
  reason: string,
}): Promise<any> =>
  client
    .post(EMAIL_UNSUBSCRIBE_ENDPOINT, {
      body: data,
    })
    .then((res) => res.success)

export default unsubscribeEmail
